
/* Funzione per la visualizzazione delle immagini della modalità di mezzo  */

import React from 'react';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import DirectionsBus from '@material-ui/icons/DirectionsBus';
import TrainIcon from '@material-ui/icons/Train';
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat';
import FlightIcon from '@material-ui/icons/Flight';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import '../List/ItemStyle.css'


export const switchMezziImage = (mode) => {
  switch (mode){
      case 'WALK':
          return (<DirectionsWalkIcon style={{fontSize:'25px'}}/>)            
      case 'BUS':
          return (<DirectionsBus style={{fontSize:'25px'}}/>);
      case 'CAR':
          return (<DirectionsCarIcon style={{fontSize:'25px'}}/>);
      case 'RAIL':
          return (<TrainIcon style={{fontSize:'25px'}}/>);
      case 'TRAM':
          return (<TrainIcon style={{fontSize:'25px'}}/>);
      case 'SUBWAY':
          return (<TrainIcon style={{fontSize:'25px'}}/>);
      case 'FUNICULAR':
          return (<TrainIcon style={{fontSize:'25px'}}/>);               
       case 'GONDOLA':
          return (<TrainIcon style={{fontSize:'25px'}}/>);
      case 'BICYCLE':
          return (<DirectionsBikeIcon style={{fontSize:'25px'}}/>);
      case 'FERRY':
          return (<DirectionsBoatIcon style={{fontSize:'25px'}}/>);
      case 'AIRPLANE':
          return (<FlightIcon style={{fontSize:'25px'}}/>);
        case 'airplane':
            return (<FlightIcon style={{fontSize:'25px'}}/>);
        case 'TRANSIT':
            return (<div><DirectionsBus style={{fontSize:'12px'}}/>
            <DirectionsBoatIcon style={{fontSize:'12px'}}/></div>);
      default:
          return (<div><DirectionsBus style={{fontSize:'12px'}}/>
          <DirectionsBoatIcon style={{fontSize:'12px'}}/></div>);
  }
}